import Service from "./service.abstract";

export default class MessageHomeDeclineService extends Service {
  constructor(url: string) {
    super();

    this.url = url;
    this.errorTopic = "service.error.messagehomedeclineservice";
  }
}
